// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1yGWN","list":"BalanceDue_list__3ymw5","listRow":"BalanceDue_listRow__2atbR","total":"BalanceDue_total__2CQX6"};